import script from "./UserTripListComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./UserTripListComponent.vue?vue&type=script&setup=true&lang=js"

import "./UserTripListComponent.vue?vue&type=style&index=0&id=9b95c91a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b95c91a"]])

export default __exports__